@if (initialized) {
    <div class="flex flex-column gap-3 p-3">

        <!-- Sprint Header -->
        @if (sprintDto) {
            <div class="flex align-items-center justify-content-between surface-card border-round-lg p-3">
                <div class="flex align-items-center gap-3">
                    <i class="fa-regular fa-forward text-2xl text-primary"></i>
                    <div>
                        <div class="text-2xl font-bold text-color">{{ sprintDto.name }}</div>
                        <div class="text-sm text-gray-600">{{ sprintDto.projectDtoName }}</div>
                    </div>
                </div>
                <div class="flex align-items-center gap-2">
                    <p-tag [value]="getSprintStatusLabel()" [severity]="getSprintStatusSeverity()"></p-tag>
                    @if (sprintDto.status === 0) {
                        <p-button label="Start Sprint"
                                  icon="fa-regular fa-play"
                                  severity="success"
                                  [loading]="sprintBusy"
                                  (onClick)="handleStartSprint()">
                        </p-button>
                    }
                    @if (sprintDto.status === 1) {
                        <p-button label="Complete Sprint"
                                  icon="fa-regular fa-check"
                                  severity="info"
                                  [loading]="sprintBusy"
                                  (onClick)="handleCompleteSprint()">
                        </p-button>
                    }
                </div>
            </div>
        }

        <!-- Sprint Details Widget -->
        @if (sprintDataWidget) {
            <mvs-widget [widgetData]="sprintDataWidget"></mvs-widget>
        }

        <!-- Sprint Tickets Widget -->
        @if (ticketWidget) {
            <mvs-widget [widgetData]="ticketWidget"></mvs-widget>
        }
    </div>
}

<!-- Loading State -->
@if (!initialized) {
    <div class="flex flex-column gap-3 p-3">
        <p-skeleton height="4rem" class="mb-3"></p-skeleton>
        <p-skeleton height="20rem"></p-skeleton>
    </div>
}
